import { IconChevronRight } from "../../components/icons.jsx";
import "./event-hub.css";

export function EventEntry({ onOpen }) {
  return <button type="button" className="halloween-event-entry" onClick={onOpen}>
    <img src="/assets/home-halloween/pumpkin-v2.webp" alt="" />
    <span><b>Хэллоуин</b><small>Ночной полёт · Акция · Набор</small></span>
    <IconChevronRight aria-hidden="true" />
  </button>;
}
